// Async Thunk for SignIn
import { createAsyncThunk } from "@reduxjs/toolkit";
import * as CognitoService from "../service/cognito";


export const signOutAction = createAsyncThunk(
  "auth/signOut",

  async (username: string) => {
    const response = await CognitoService.signOut(username);
    return JSON.parse(JSON.stringify(response));
  },
);
